/**
 * @generated SignedSource<<2e5e0a9c7ff627dcd83ff64c9f7f8d06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferSubmit_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly city: string | null;
      readonly country: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly line1: string | null;
      readonly line2: string | null;
      readonly serviceId: string | null;
      readonly state: string | null;
      readonly zipCode: string | null;
    } | null> | null;
  } | null;
  readonly isVerifiedTrade: boolean | null;
  readonly isVip: boolean | null;
  readonly tradeFirm: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "CheckoutWireTransferSubmit_buyer";
};
export type CheckoutWireTransferSubmit_buyer$key = {
  readonly " $data"?: CheckoutWireTransferSubmit_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferSubmit_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferSubmit_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    },
    {
      "alias": "isVerifiedTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "line1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "line2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "kind": "LinkedField",
      "name": "tradeFirm",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "750691e4c096ebd414591508e1169757";

export default node;
